import React, { useState, useEffect } from 'react';
import { lowerCase, values, drop, startCase } from 'lodash';
import { Table, PageTitle } from '@cordata/buffet';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert } from 'reactstrap';

import {
  referenceAdminInstance as refAdmin,
} from '~/utils';

const columns = [{
  id: 'name',
  Header: 'Name',
  accessor: type =>
    drop(startCase(type.name).split(' ')).join(' '),
  filterMethod: (filter, row) =>
    lowerCase(row[filter.id]).includes(lowerCase(filter.value)),
}];

const defaultSorted = [{
  id: 'name',
}];

const customList = [
  'AiAvailableResource',
  'GeneralEvent',
  'PublicResource',
  'MedicalEvent',
  'NavItem',
  'ReportConfiguration',
  'SecurityGroup',
  'SecurityPermissionContext',
].map(r => `Reference${r}`);

const ReferenceAdminTypes = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    refAdmin
      .get('/available')
      .then(r => r.data)
      .then(r => setData(values(r).filter(t => !customList.includes(t.name))))
      .then(() => setLoading(false));
  }, []);

  return (
    <>
      <PageTitle>Generic Reference Data</PageTitle>

      <Alert color="info">
        <FontAwesomeIcon icon="info-circle" className="mr-2" fixedWidth />
        If you don&apos;t see an item in list, chances are it has a specific page.
      </Alert>

      <Table
        data={data}
        columns={columns}
        loading={loading}
        defaultSorted={defaultSorted}
        filterable
        getTrProps={(state, rowInfo) => ({
          style: {
            cursor: 'pointer',
          },
          onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/toolbox/generic/${rowInfo.original.name}`)),
        })}
      />
    </>
  );
};

export default ReferenceAdminTypes;
